import React from "react";

export default function countDescendants(parent, descendantTypes) {
  if (!parent) return 0;
  const children = parent.props ? React.Children.toArray(parent.props.children) : [];
  let count = 0;
  if (
    !descendantTypes ||
    (parent.type &&
      parent.type.displayName &&
      descendantTypes.indexOf(parent.type.displayName) >= 0)
  ) {
    count += 1;
  }
  if (children.length <= 0) {
    return count;
  }
  return children.reduce(
    (childCount, child) =>
      childCount + countDescendants(child, descendantTypes),
    count
  );
}
